import { localePrice } from "helpers/locales";

const ServicesInfo = ({ services }) => {
  return (
    <div className="services-info">
      {services.map((service) => {
        const baseTotal = Number(service.unit_price) * Number(service.quantity);
        const hasDiscount = Number(service.discount) > 0;

        return (
          <article key={service.id} className="service-item">
            <header className="service-item-header">
              <h6>{service.name}</h6>
              <span className="service-item-meta">
                {localePrice(service.unit_price)} × {service.quantity}
              </span>
            </header>
            <ul className="participant-cost">
              {hasDiscount && (
                <>
                  <li>
                    <p>Базовая стоимость</p>
                    <p className="base">{localePrice(baseTotal)}</p>
                  </li>
                  <li>
                    <p>{service.discount_text || "Скидка"}</p>
                    <p className="discount">
                      − {localePrice(service.discount)}
                    </p>
                  </li>
                </>
              )}
              <li>
                <p>Цена</p>
                <p className="total">{localePrice(service.total_price)}</p>
              </li>
            </ul>
          </article>
        );
      })}
    </div>
  );
};

export default ServicesInfo;
